<template>
  <div>
    <Loading v-if="loading"></Loading>
    <Layout v-else>
      <div class="pt-4">
        <h3 style="font-weight: bold">POS Transactions</h3>
      </div>
      <section class="pt-5">
        <Overview class="overview">
          <p slot="card-1-title">Total POS Transaction Value</p>
          <h3 slot="card-1-val">
            ₦<ICountUp
              :delay="delay"
              :endVal="totalPosSumValue"
              :options="options"
              @ready="getTotalPosSumValue"
            />
          </h3>
          <!-- <span slot="card-1-percent">+95%</span>
          <span slot="from" class="grey-color pl_4">from last month</span> -->

          <p slot="card-2-title">Total POS Transaction Volume</p>
          <h3 slot="card-2-val">
            <ICountUp
              :delay="delay"
              :endVal="totalPosVolume"
              :options="options"
              @ready="getTotalPosVolume"
            />
          </h3>
          <!-- <span slot="card-2-percent">+19%</span> -->

          <p slot="card-4-earnings">Total Earnings</p>
          <h3 slot="card-4-val">Coming Soon</h3>
          <!-- <span slot="card-4-percent"></span> -->
          <span></span>
        </Overview>
      </section>
      <section class="pt-5">
        <TransactionsList>
          <b-form-input
            slot="search-bar"
            class="d-none"
            type="search"
            placeholder="Search by name, agent id or terminal id"
            trim
          />
          <b-button slot="search-btn" class="d-none" variant="primary"
            >Search</b-button
          >
          <b-form-select
            class="show-select"
            slot="select-entry"
            value="1"
            :options="posEntries"
          ></b-form-select>
          <span slot="entries-no">of {{ posEntries.length }} entries</span>
          <b-form-datepicker
            slot="start-date"
            id="pos-start-date"
            placeholder="Start date"
            locale="en"
            class="filter-date"
            :max="today"
            @input="enableEndDate"
            v-model="startDate"
          ></b-form-datepicker>
          <b-form-datepicker
            slot="end-date"
            id="pos-end-date"
            placeholder="End date"
            locale="en"
            class="filter-date"
            :disabled="disabled"
            :min="startDate"
            :max="today"
            @input="enableApply"
            v-model="endDate"
          ></b-form-datepicker>
          <b-form-input
            slot="start-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="end-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="status-input"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-checkbox
            slot="save-default"
            class="save-filter"
            id="save-filter"
          >
            Save as default filter
          </b-form-checkbox>
          <b-button
            slot="clear-btn"
            class="btn-alt filter-btn"
            block
            variant="primary"
          >
            Clear
          </b-button>
          <b-button
            slot="apply-btn"
            slot-scope="{ closeModal }"
            class="filter-btn"
            block
            variant="primary"
            :disabled="disabledApply"
            @click="
              closeModal();
              applyFilter();
            "
          >
            Apply
          </b-button>
          <b-table slot="table" hover :items="posTableData"></b-table>
        </TransactionsList>
      </section>
    </Layout>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import TransactionsList from "@/components/TransactionsList.vue";
import Overview from "@/components/Overview.vue";
import ICountUp from "vue-countup-v2";
import { mapState, mapActions } from "vuex";

export default {
  name: "PosTransactions",
  components: {
    Loading,
    Layout,
    Overview,
    ICountUp,
    TransactionsList,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      disabled: true,
      disabledApply: true,
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.pos.initialLoad,
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,
      today: (state) => state.user.today,

      totalPosSumValue: (state) => state.pos.posOverview.totalSumValue,
      totalPosVolume: (state) => state.pos.posOverview.totalCount,
      // totalPosEarnings: (state) => state.pos.posOverview.earnings,
      posTableData: (state) => {
        if (state.pos.posTransactions.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.pos.posTransactions.data;
        }
      },
      posEntries: (state) => {
        if (state.pos.posTransactions.data > 0) {
          return [...state.pos.posTransactions.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
    }),
  },
  methods: {
    ...mapActions({
      posTransactions: "pos/getPosTransactions",
      posOverview: "pos/getPosOverview",
    }),
    getTotalPosSumValue(instance) {
      const that = this;
      instance.update(that.totalPosSumValue);
    },
    getTotalPosVolume(instance) {
      const that = this;
      instance.update(that.totalPosVolume);
    },
    // getTotalPosEarnings(instance) {
    //   const that = this;
    //   instance.update(that.totalPosEarnings);
    // },
    applyFilter() {
      this.posTransactions({
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    clearFilter() {
      (this.startDate = ""), (this.endDate = "");
    },
    enableEndDate() {
      this.disabled = false;
    },
    enableApply() {
      this.disabledApply = false;
    },
  },
  created() {
    this.posTransactions({ startDate: this.today, endDate: this.today });
    this.posOverview({ startDate: this.today, endDate: this.today });
  },
};
</script>

<style></style>
